import React, { useState, useMemo } from "react";
import { Modal, Input, Button, Select, InputNumber, Switch, message } from "antd";

/**
 * 根据参数类型渲染对应的输入控件
 */
const ParamInput = ({ param, value, onChange }) => {
  const label = `${param.description}${param.required ? " *" : ""}`;

  switch (param.type) {
    case "number":
      return (
        <div style={{ marginBottom: 8 }}>
          <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>{label}</div>
          <InputNumber
            value={value}
            onChange={(v) => onChange(param.name, v)}
            style={{ width: "100%" }}
            placeholder={param.description}
            disabled={false}
          />
        </div>
      );
    case "boolean":
      return (
        <div style={{ marginBottom: 8 }}>
          <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>{label}</div>
          <Switch
            checked={!!value}
            onChange={(v) => onChange(param.name, v)}
          />
        </div>
      );
    case "string":
    default:
      return (
        <div style={{ marginBottom: 8 }}>
          <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>{label}</div>
          <Input
            value={value}
            onChange={(e) => onChange(param.name, e.target.value)}
            placeholder={param.description}
            disabled={false}
          />
        </div>
      );
  }
};

/**
 * 控制假人模态框 — 发送命令 + 执行预设动作（动态参数）
 */
const ControlBotModal = ({
  visible,
  bot,
  loading,
  actions,
  onSendCommand,
  onExecuteAction,
  onCancel,
}) => {
  const [commandInput, setCommandInput] = useState("");
  const [selectedAction, setSelectedAction] = useState(null);
  const [paramValues, setParamValues] = useState({});

  // 当前选中动作的参数描述符
  const currentParams = useMemo(() => {
    if (!selectedAction) return [];
    return selectedAction.params || [];
  }, [selectedAction]);

  const handleSendCommand = async () => {
    if (!commandInput.trim()) {
      message.warning("请输入命令");
      return;
    }
    await onSendCommand(commandInput);
    setCommandInput("");
  };

  const handleActionChange = (actionStr) => {
    const action = actions.find((a) => a.action === actionStr) || null;
    setSelectedAction(action);
    setParamValues({});
  };

  const handleParamChange = (name, value) => {
    setParamValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleExecuteAction = async () => {
    if (!selectedAction) {
      message.warning("请选择一个动作");
      return;
    }

    // 校验必填参数
    for (const param of currentParams) {
      if (param.required && (paramValues[param.name] === undefined || paramValues[param.name] === "" || paramValues[param.name] === null)) {
        message.warning(`请填写必填参数: ${param.description}`);
        return;
      }
    }

    const params = { ...paramValues };
    await onExecuteAction(selectedAction.action, params);
  };

  if (!bot) return null;

  return (
    <Modal
      title={`控制假人 - ${bot.name || ""}`}
      open={visible}
      onCancel={onCancel}
      footer={null}
      className="botcontrol-modal"
      width={600}
    >
      <div className="control-modal-content">
        <div className="form-group" style={{ marginBottom: "20px" }}>
          <label
            className="form-label"
            style={{ display: "block", marginBottom: "8px" }}
          >
            输入要执行的命令
          </label>
          <Input
            type="text"
            className="form-input"
            placeholder="例如: /tpa tiancuo"
            value={commandInput}
            onChange={(e) => setCommandInput(e.target.value)}
            disabled={loading}
            onPressEnter={handleSendCommand}
          />
          <Button
            type="primary"
            onClick={handleSendCommand}
            loading={loading}
            style={{ width: "100%", marginTop: "10px" }}
          >
            发送命令
          </Button>
        </div>

        <div className="form-group" style={{ marginBottom: "20px" }}>
          <label
            className="form-label"
            style={{ display: "block", marginBottom: "8px" }}
          >
            执行预设动作
          </label>
          <Select
            value={selectedAction?.action || undefined}
            onChange={handleActionChange}
            style={{ width: "100%", marginBottom: "10px" }}
            disabled={loading}
            placeholder="请选择动作"
            allowClear
          >
            {actions.map((act) => (
              <Select.Option key={act.action} value={act.action}>
                {act.description}
              </Select.Option>
            ))}
          </Select>

          {/* 动态参数输入 */}
          {currentParams.length > 0 && (
            <div
              style={{
                padding: "12px",
                backgroundColor: "#fafafa",
                borderRadius: 6,
                marginBottom: 10,
              }}
            >
              {currentParams.map((param) => (
                <ParamInput
                  key={param.name}
                  param={param}
                  value={paramValues[param.name]}
                  onChange={handleParamChange}
                />
              ))}
            </div>
          )}


          <Button
            type="primary"
            onClick={handleExecuteAction}
            loading={loading}
            disabled={!selectedAction}
            style={{ width: "100%" }}
          >
            执行动作
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ControlBotModal;
